import React from "react";
import { Property } from "./Property";
import s from "components/ProductConfigurator/ProductConfigurator.module.scss";
import { useProductOutput } from "stores/product";
import cx from "classnames";

export const TechnicalInputList = ({
  headerStyles,
  propertyStyles,
  disabled = false,
}: {
  headerStyles?: string;
  propertyStyles?: string;
  disabled?: boolean;
}) => {
  const productOutput = useProductOutput();
  const inputs = productOutput?.product?.inputs;
  return (
    <div className="position-relative px-4">
      {inputs?.map((input, index) => (
        <div key={index} className={cx("pt-4", s.cardInputSection)}>
          <h5 className={headerStyles}>{input?.presentation}</h5>
          {input?.properties?.map(
            (property) =>
              property && (
                <Property
                  key={property?.id}
                  property={property}
                  isValueEditable={!disabled}
                  propertyStyles={propertyStyles}
                />
              ),
          )}
        </div>
      ))}
    </div>
  );
};
